module.exports = __webpack_public_path__ + "static/media/05_4.61805dec.png";